function ThirdPage() {
  return (
    <div>
      <img
        src="/images/bg-gradient-orange.png"
        alt=""
        className="-z-10 w-96 sm:w-auto absolute top-[270%] sm:top-[280%] above-1100:top-[230%] left-0"
      />
      <img
        src="/images/bg-gradient-green.png"
        alt=""
        className="absolute -z-10 right-0 w-[26rem] sm:w-auto"
      />
      <div id="container" className=" w-[80%] mx-auto mt-12">
        <div className="flex justify-between flex-row">
          <div className="w-[50%]  hidden lg:block">
            <img
              src="/images/star-img.png"
              alt=""
              className="relative top-[20%] xl:left-[20%]"
            />
            <img
              src="/images/shield.png"
              alt=""
              className="relative lg:left-[20%] xl:left-[40%] top-[5%]"
            />
            <img
              src="/images/sphere-brown-2.png"
              alt=""
              className="lg:left-[10%] xl:left-[30%] relative z-[-1] bottom-[33%] "
            />
          </div>
          <div className="text-white flex flex-col justify-center items-center gap-6 max-w-[40rem]  mx-auto text-center lg:text-start lg:w-[50%]">
            <h1 className="text-4xl sm:text-6xl font-bold ">
              24/7 access to full service customer support
            </h1>
            <p className="text-gray-500">
             Whether it’s day or night, our support team is always here to help you resolve issues quickly and easily.
            </p>
            <button className="lg:self-start  border border-white px-6 py-4 rounded-xl inline-block">
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThirdPage;
